import setCurrentPage from "src/Utils/setCurrentPage";
import store from "src/Reducers/store";

const previousPage = () => store.getState().appReducer.previousPage;

export const DATA_ENTERPRISE_DEMO_IEAM_1 = {
  title: "Catalog view of \n published software",
  subtitle: "Enterprise demo",
  text: "The enterprise customer can see all published\n software in a catalog view.",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_112"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(previousPage()),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/IEAM/IEAM_Enterprise_demo_screens_01.png",
  rightSideImage: "ENG/IEAM/IEAM_Enterprise_demo_screens_01-1.png",
};
